import React from 'react';
import { Grid } from '@mui/material';
import i18n from 'i18';
import {
    AppTotalUsersChart,
    AppMonthlyTransactionVolumeChart
} from './widgets';
import { useTheme } from '@mui/material/styles';
import config from '../../config';
// import useResponsive from '../../hooks/useResponsive';

const ChartsSection = ({
    transactionVolumesByDate,
    datesLabelsTransactionVolumes,
    totalActiveWallets,
    totalInactiveWallets
}) => {
    const theme = useTheme();
    // const isMobile = useResponsive('down', 'sm');
    const gradients = theme.palette.dashboardGradients;
    const defaultGradient = theme.palette.defaultDashboardGradient;

    const getGradient = (index) => {
        return gradients[index % gradients.length] || defaultGradient;
    };

    const hiddenField = config.chartSettings.hiddenFields;

    const filteredTransactionVolumesByDate = Object.fromEntries(
        Object.entries(transactionVolumesByDate).filter(
            ([key]) => !hiddenField.includes(key)
        )
    );

    return (
        <>
            <Grid item xs={12} md={6} lg={6}>
                <AppMonthlyTransactionVolumeChart
                    title={i18n.t('dashboard.transactionVolumesByDate')}
                    chartInfoTitle={i18n.t(
                        'dashboard.totalTransactionVolumesInfoTitle'
                    )}
                    chartInfoSubtitle={i18n.t(
                        'dashboard.totalTransactionVolumesInfoSubtitle'
                    )}
                    chartLabels={datesLabelsTransactionVolumes || []}
                    chartData={Object.entries(filteredTransactionVolumesByDate).map((field, index) => {
                        const gradient = getGradient(index);
                        return {
                            name: field[0],
                            type: 'line',
                            data: field[1].map(d => Math.round(d)),
                            color: gradient.start,
                            endColor: gradient.end
                        };
                    })}
                />
            </Grid>
            <Grid item xs={12} md={6} lg={6}>
                {totalActiveWallets > 0 && totalInactiveWallets > 0 && (
                    <AppTotalUsersChart
                        title={i18n.t('dashboard.totalWallets')}
                        // customLegend={!isMobile}
                        chartData={Object.entries({
                            totalActiveWallets,
                            totalInactiveWallets
                        }).map((field, index) => {
                            const gradient = getGradient(index);
                            return {
                                label: i18n.t(`dashboard.${field[0]}`),
                                value: field[1],
                                color: gradient.start,
                                endColor: gradient.end
                            };
                        })}
                        chartInfo={[
                            {
                                title: i18n.t('dashboard.activeWalletsTitle'),
                                subtitle: i18n.t('dashboard.activeWalletsSubtitle'),
                                value: totalActiveWallets
                            },
                            {
                                title: i18n.t('dashboard.inactiveWalletsTitle'),
                                subtitle: i18n.t('dashboard.inactiveWalletsSubtitle'),
                                value: totalInactiveWallets
                            }
                        ]}
                    />
                )}
            </Grid>
        </>
    );
};

export default ChartsSection;
